import { useEffect } from 'react';
export function useOnce(effect) {
    return useEffect(effect, []);
}
export function useOnceAsync(effect) {
    return useOnce(function () {
        effect();
    });
}
//# sourceMappingURL=use-once.js.map